import React from 'react'

import Modal from '@material-ui/core/Modal';

import SpotlioIcon from '../Icon';
import Divider from "../Divider";
import Typography from "../Typography";

import './index.scss';

export default ({ className, title, open, children, closeFn, footerContent, closeOnBackDrop, noCloseButton, backDropClassName }) => {
    let isOpen = open;

    
    return(
        <Modal
            className="modal"
            open={isOpen}
            BackdropProps={{
                className: backDropClassName
            }}
            disablePortal={true}
            onBackdropClick={closeOnBackDrop ? closeFn : null}
            onEscapeKeyDown={closeOnBackDrop ? closeFn : null}
        >
            <div className={"generalModal " + className}>
                <div className="header">
                    <Typography className="h700">{title}</Typography>
                    {noCloseButton ? null : <SpotlioIcon icon={"feather-x"} size={24} onClick={ closeFn } />}
                    <Divider />
                </div>
                <div className="content">
                    {children}
                </div>
                <div className="footer">
                    {footerContent}
                </div>
            </div>
        </Modal>
    );
}
